import type { FunctionComponent } from 'react';
import { Fragment } from 'react';

import { FeedbackTextInput } from './FeedbackTextInput';
import { SkillOrSkillSearchAutocomplete } from './SkillOrSkillSearchAutoComplete';
import { useFeedbackDialogStore } from './use-feedback-dialog-store';

type ReportSkillTabContentProps = {
    readonly descriptionValue: string;
    readonly onDescriptionChange: (input: string) => void;
};

export const ReportSkillTabContent: FunctionComponent<ReportSkillTabContentProps> = ({
    descriptionValue,
    onDescriptionChange,
}) => {
    const reportSkillReasonLabel = useFeedbackDialogStore((state) => state.reportSkillReasonLabel);
    const reportSkillReasonPlaceholderLabel = useFeedbackDialogStore(
        (state) => state.reportSkillReasonPlaceholderLabel,
    );

    return (
        <Fragment>
            <SkillOrSkillSearchAutocomplete currentFeedbackType="report" />
            <FeedbackTextInput
                placeholder={reportSkillReasonPlaceholderLabel}
                required={true}
                title={reportSkillReasonLabel}
                value={descriptionValue}
                onChange={onDescriptionChange}
            />
        </Fragment>
    );
};
